function BankFormatTable({ modalPreviewTableData }) {
  return (
    <div className="card p-3 mb-3">
      <div className="table-responsive">
        <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>#</th>
              <th>1:</th>
              <th>2:</th>
              <th>3:</th>
              <th>4:</th>
              <th>:20:</th>
              <th>:23B:</th>
              <th>:32A:</th>
              <th>:50A:</th>
              <th>:57A:</th>
              <th>:59:</th>
              <th>:70:</th>
              <th>:71A:</th>
              <th>:72:</th>
            </tr>
          </thead>
          <tbody>
            {modalPreviewTableData.map((row, idx) => (
              <tr key={row.id}>
                <td>{idx + 1}</td>
                <td>{row.col1}</td>
                <td>{row.col2}</td>
                <td>{row.col3}</td>
                <td>{row.col4}</td>
                <td>{row.col20}</td>
                <td>{row.col23B}</td>
                <td>{row.col32A}</td>
                <td>{row.col50A}</td>
                <td>{row.col57A}</td>
                <td>{row.col59}</td>
                <td>{row.col70}</td>
                <td>{row.col71A}</td>
                <td>{row.col72}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default BankFormatTable;
